import { WORKSPACE_DETAILS_FORM_FIELDS } from './fieldNames';
import { WorkspaceDetailsFormValues } from './types';

/** The form fields that make up the street-address group (APP-1829). */
export const ADDRESS_GROUP_FIELDS = [
  WORKSPACE_DETAILS_FORM_FIELDS.addressCity,
  WORKSPACE_DETAILS_FORM_FIELDS.addressCountry,
  WORKSPACE_DETAILS_FORM_FIELDS.addressLine1,
  WORKSPACE_DETAILS_FORM_FIELDS.addressPostcode,
  WORKSPACE_DETAILS_FORM_FIELDS.addressState,
] as const satisfies readonly (keyof WorkspaceDetailsFormValues)[];

export type AddressGroupField = (typeof ADDRESS_GROUP_FIELDS)[number];

/**
 * The address section is all-or-nothing: legacy workspaces (postal-only or no
 * addresses at all) prefill the group blank and must still be able to save
 * the entity/contact sections, so address requiredness only arms once any
 * field in the group has content.
 */
export const addressGroupHasContent = (
  values: readonly (string | undefined)[],
) => values.some((value) => Boolean(value?.trim()));

/**
 * Each group field's schema conditionally depends on its siblings, which
 * yup's dependency sort treats as a cycle — exclude these edges via
 * `yup.object().shape(shape, ADDRESS_GROUP_EDGES)`.
 */
export const ADDRESS_GROUP_EDGES = ADDRESS_GROUP_FIELDS.flatMap(
  (fieldA, index) =>
    ADDRESS_GROUP_FIELDS.slice(index + 1).map(
      (fieldB) => [fieldA, fieldB] as [string, string],
    ),
);
